// extracted by mini-css-extract-plugin
export default {"item":"GetOffer3Item_item__-D-VV","buttons":"GetOffer3Item_buttons__lv3o2"};